import { render } from "./tiktok-form.vue?vue&type=template&id=64b6c637"
import script from "./tiktok-form.vue?vue&type=script&lang=js"
export * from "./tiktok-form.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__